import { FC } from 'react'
import useTranslation from 'next-translate/useTranslation'

import SearchMenuItem from './SearchMenuItem'
import SupplierSuggestionList from '../../../Search/SupplierSuggestionList'

import styles from '../../../../styles/Search.module.less'

interface DropdownMenuData {
  value: string
  label: string
  highlight?: TrustedHTML
  userTyped?: boolean
}

interface SearchDropdownMenuProps {
  searchMenuData: DropdownMenuData[]
  searchTerm: string
  brandList: (DropdownMenuData & { id: string })[]
  onItemClick: (label: string) => void
  onSupplierClick: (supplierId: string) => void
  typesenseQuery: string
  refine: (q: string) => void
}

const SearchDropdownMenu: FC<SearchDropdownMenuProps> = ({
  searchMenuData,
  searchTerm,
  brandList,
  onItemClick,
  onSupplierClick,
  typesenseQuery,
  refine,
}) => {
  const { t } = useTranslation('modals')

  const noSearchResults = searchMenuData.length === 1 && searchMenuData[0].userTyped

  if (noSearchResults) {
    // No actual results returned - reset search to show popular searches
    refine('')
  }

  const list = searchTerm && searchTerm === typesenseQuery
    ? searchMenuData
    : [
      { label: 'Popular Searches', value: '' },
      ...searchMenuData,
    ]

  const queryList = list.map(({ label, highlight }) => {
    if (label === 'Popular Searches') {
      return (
        <SearchMenuItem
          key={label}
          label={t(label)}
          isHeader
        />
      )
    }

    return (
      <SearchMenuItem
        key={label}
        label={label}
        highlight={highlight}
        onClick={() => onItemClick(label)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            onItemClick(label)
          }
        }}
      />
    )
  })

  return (
    <div
      role="listbox"
      className="rs-auto-complete-menu rs-auto-complete-menu-items"
    >
      {noSearchResults || searchTerm !== typesenseQuery ? (
        <span className={`rs-auto-complete-item ${styles['search-header']}`}>
          {t('No results for {{ searchTerm }}', { searchTerm })}
        </span>
      ) : null}
      {queryList}
      {!typesenseQuery ? (
        <SupplierSuggestionList
          supplierList={brandList}
          onSupplierClick={onSupplierClick}
        />
      ) : null}
    </div>
  )
}

export default SearchDropdownMenu
export type { DropdownMenuData }
